
var removeCmsImageWidthHeight = (function () {

    var setUpRemoveCmsImageWidthHeight = function () {
        if($('.c-cms-scalable-image').length){
            $('.c-cms-scalable-image').each(function(){
                $(this).removeAttr('width');
                $(this).removeAttr('height');
            })
        }
    };

  function init() {
    setUpRemoveCmsImageWidthHeight();
  };

  return {
    init: init
  };
})();

export default removeCmsImageWidthHeight;



// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/removeCmsImageWidthHeight.js